import Vue from 'vue'
Vue.directive('money', {
  inserted(el, binding) {
    el.innerText = init(binding.value)
  },
  update(el, binding) {
    el.innerText = init(binding.value)
  }
})

function init(value) {
  if (!value) return 0
  if (isNaN(value)) return value
  value = Math.ceil(value) / 100 // 转换为元
  const num = 2
  if (parseFloat(value) > 0) {
    const str = parseFloat(value).toFixed(num)
    const strArr = str.split('.')
    return /^0+$/.test(strArr[1]) ? strArr[0] : str
  } else {
    return 0
  }
}
